import { create } from 'zustand';

export interface LogEntry {
  id: number;
  ts: string;
  level: 'info' | 'warn' | 'error' | 'success';
  message: string;
  runId: string | null;
}

interface LogState {
  entries: LogEntry[];
  push: (entry: Omit<LogEntry, 'id'>) => void;
  clear: () => void;
}

let counter = 1;

export const useLogStore = create<LogState>((set) => ({
  entries: [],
  push: (entry) =>
    set((state) => ({ entries: [...state.entries.slice(-499), { ...entry, id: counter++ }] })),
  clear: () => set({ entries: [] }),
}));
